module.exports = __webpack_public_path__ + "static/img/mail-game-4.a784a65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mail-game-4.png
// module id = wwpS
// module chunks = 1